import React from "react";
import "../less/main.less";
import DOMPurify from 'utils/sanitize';

export default function template() {
  const { page, items, toggleFaqTab, title, disableScrollTarget, questionTag = "h3", subtitle } = this.props;

  const QuestionTag = questionTag

  const rows = items.map((item, index) => {
    return (
      <div className="faq-new__row" key={index} id={!disableScrollTarget && index === 0 ? 'frequentlyAskedQuestions' : undefined}>
        <QuestionTag className="faq-new__question" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(item.question))}}></QuestionTag>
        <div className="faq-new__answer answer-faq-new">
          <div dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(this.l10n(item.answer), {
              ADD_ATTR: ['target', 'rel'],
              ALLOWED_ATTR: ['href', 'target', 'rel', 'class'],
              HOOKS: {
                afterSanitizeAttributes: (node) => {
                  if (node.tagName === 'A' && node.hasAttribute('target')) {
                    node.setAttribute('rel', 'noopener noreferrer');
                  }
                }
              }
            })
          }}></div>
          {item.img1 && 
            <div className="faq-new__images">
              {item.img1 && <img className="faq-new__image" src={item.img1} alt={this.l10n(item.img1Alt)} loading="lazy"/>}
              {item.img2 && <img className="faq-new__image" src={item.img2} alt={this.l10n(item.img2Alt)} loading="lazy"/>}
            </div>
          }
        </div>
      </div>
    );
  });

  return (
    <div className="faq-new" ref={this.faqRef}>
      <div className="container">
        {(title || subtitle) && (
          <div className="faq-new__top">
            {title && <h2 className="faq-new__title">{this.l10n(title)}</h2>}
            {subtitle && <div className="faq-new__subtitle">{this.l10n(subtitle)}</div>}
          </div>
        )}
        <div className="faq-new__body">
          {rows}
        </div>
        {toggleFaqTab && <button className="faq-new__btn" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('FAQ_SHORT_NEW_BTN'))}} onClick={toggleFaqTab} id={`${page ? page : ''} faq-button`}></button>}
      </div>
    </div>
  );
}
